import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const bookingApi = {
  availability: (date) => axios.get(`${API}/availability`, { params: { date } }),
  create: (data) => axios.post(`${API}/bookings`, data),
};

export function bookingErr(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
